import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({ color, size, style, className, noFill }: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 1.5C12.2455 1.5 12.4496 1.67688 12.4919 1.91012L12.5 2V11.5H22C22.2761 11.5 22.5 11.7239 22.5 12C22.5 12.2455 22.3231 12.4496 22.0899 12.4919L22 12.5H12.5V22C12.5 22.2761 12.2761 22.5 12 22.5C11.7545 22.5 11.5504 22.3231 11.5081 22.0899L11.5 22V12.5H2C1.72386 12.5 1.5 12.2761 1.5 12C1.5 11.7545 1.67688 11.5504 1.91012 11.5081L2 11.5H11.5V2C11.5 1.72386 11.7239 1.5 12 1.5Z" />
    </svg>
  );
}